import React from 'react'
import FromPageIndicator from '../Common/FromPageIndicator'
import VenueSection from './VenueSection'

const VenuePage = () => {
  return (
    <>
    <FromPageIndicator />
    <VenueSection />
    </>
  )
}

export default VenuePage